const aboutMenu = () => {
    $(".about-menu").on("mouseover", "li", function () {
        const $parent = $(this).parents(".about-menu");
        //kiểm tra đang chạy animation không
        if ($parent.attr("data-changing") == "1") return;

        const $indicator = $parent.find(".indicator");
        const menuItemHeight = $(this).height();
        const menuItemWidth = $(this).width();
        const newTop = $(this).position().top + 0
        console.log(newTop, menuItemHeight)
       
        $indicator.css({
            transform: `translateY(${newTop}px)`,
            height: menuItemHeight
        });
        
        $indicator.find(".underline").css({
            width: $(this).find("a").width() + 15
        })
        $(".about-menu li").removeClass("text-red")
        $(this).addClass("text-red")
    })
    $(".about-menu").on("mouseleave", "ul", function () {
        $(".about-menu li.active").mouseover();
    })
    $(".about-menu li.active").mouseover();
}

module.exports = aboutMenu;